import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import store from '../../store/store';
interface Props {
  identifier: any;
  password: any;
  history: any;
  auth: any;
}

function mapDispatchToProps(dispatch: any) {
  return {
    identifier: (payload: string) =>
      dispatch({
        type: 'UPDATE_IDENTIFIER',
        payload,
      }),
    password: (payload: string) =>
      dispatch({
        type: 'UPDATE_PASSWORD',
        payload,
      }),
  };
}
const mapStateToProps = (state: any, ownProps: any) => {
  return {
    auth: state.auth,
  };
};

class Login extends Component<Props> {
  state = {
    errorMessage: '',
    showPassword: false,
  };

  componentDidMount() {
    if (store.getState().auth.jwt) {
      this.props.history.push('/dashboard');
    }
  }

  login = async (event: { preventDefault: () => void }) => {
    const that = this;
    event.preventDefault();

    await axios
      .post(`${process.env.REACT_APP_API_SERVER}/auth/local`, {
        identifier: this.props.auth.identifier,
        password: this.props.auth.password,
      })
      .then((res: { data: Record<string, any> }) => {
        if (res.data.user) {
          store.dispatch({ type: 'UPDATE_USER', payload: res.data.user });
        }
        if (res.data.jwt) {
          store.dispatch({ type: 'JWT_STORE', payload: res.data.jwt });
          that.props.history.push('/dashboard');
        }
      })
      .catch((error: { response: { data: { message: Array<{ messages: Array<{ message: any }> }> } } }) => {
        if (error.response) {
          this.setState({
            errorMessage: error.response.data.message[0].messages[0].message,
          });
        }
      });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.imagebox}></div>
        <div className={classes.formBox}>
          <div className="flex flex-row h-screen items-center justify-center">
            <div className={classes.formContainer}>
              <div className={classes.heading}>
                <h2>
                  Login to <strong>{(process.env.REACT_APP_COURIER_COMPANY_NAME ?? '').replace(' ', '')}</strong>
                </h2>
                <p className="mb-4 text-danger">{this.state.errorMessage} </p>
              </div>

              {/* form here */}
              <form onSubmit={this.login}>
                <div>
                  <label className={classes.label} htmlFor="identifier">
                    Phone Number / Email
                  </label>
                  <input
                    type="text"
                    className={classes.input}
                    placeholder="01..."
                    id="identifier"
                    onChange={(e) => {
                      this.props.identifier(e.target.value);
                    }}
                  />
                </div>
                <label htmlFor="password" className={classes.label}>
                  Password
                </label>
                <div className="relative mb-5">
                  <input
                    type={this.state.showPassword ? 'text' : 'password'}
                    className={classes.input}
                    placeholder="Your Password"
                    id="password"
                    onChange={(e) => {
                      this.props.password(e.target.value);
                    }}
                  />
                  <span
                    className="absolute right-2 bottom-1/4"
                    onClick={() => {
                      this.setState({ showPassword: !this.state.showPassword });
                    }}
                  >
                    {!this.state.showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                  </span>
                </div>
                <div className="flex flex-nowrap justify-evenly">
                  <div>
                    <span className="m-auto">
                      <Link to="/register" className="forgot-pass">
                        Signup
                      </Link>
                    </span>
                  </div>
                  <div>
                    <span className="m-auto">
                      <Link to="/forgot-password" className="forgot-pass">
                        Forgot Password
                      </Link>
                    </span>
                  </div>
                </div>
                <input type="submit" value="Log In" className={classes.button} />
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const classes = {
  container: 'flex flex-row ',
  formContainer: 'bg-white p-10 shadow-lg',
  imagebox: 'basis-0 sm:basis-2/4  bg-cover bg-center h-screen bg-auth',
  formBox: 'w-full sm:basis-2/4 h-screen',
  heading: 'mb-14 text-center text-3xl',
  label: 'block mb-2 text-lg font-bold',
  input: 'p-3 mb-3 w-full rounded bg-gray-200',
  button: 'bg-primary-red w-full py-3 mt-5 rounded-md text-white font-bold hover:cursor-pointer',
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
